/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown>, reps: NonNullable<unknown> }} Swap_Last_Time_LoadInputs */

const en_us2_swap_last_time_load = /** @type {(inputs: Swap_Last_Time_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const pt_br2_swap_last_time_load = /** @type {(inputs: Swap_Last_Time_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const es_419_swap_last_time_load = /** @type {(inputs: Swap_Last_Time_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const pt_pt2_swap_last_time_load = /** @type {(inputs: Swap_Last_Time_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const fr_fr2_swap_last_time_load = /** @type {(inputs: Swap_Last_Time_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const de_de2_swap_last_time_load = /** @type {(inputs: Swap_Last_Time_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const it_it2_swap_last_time_load = /** @type {(inputs: Swap_Last_Time_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "{loadText} × {reps}" |
*
* @param {Swap_Last_Time_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_last_time_load = /** @type {((inputs: Swap_Last_Time_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Last_Time_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_last_time_load(inputs)
	if (locale === "es-419") return es_419_swap_last_time_load(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_last_time_load(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_last_time_load(inputs)
	if (locale === "de-DE") return de_de2_swap_last_time_load(inputs)
	if (locale === "it-IT") return it_it2_swap_last_time_load(inputs)
	return en_us2_swap_last_time_load(inputs)
});
export { swap_last_time_load as "swap.last_time_load" }